import { initPopupWidget } from './components/header/popup-widget.js'
import { initHeader } from './components/header/header.js'
import { initNavigation } from './components/header/navigation.js'
import { initProducts } from './components/product.js'
import { initFooter } from './components/footer/footer.js'
import { initHomepage } from './components/homepage/homepage.js'
import { initBlogListing } from './components/blog/blog-listing.js'
import { initCategory } from './components/category/category.js'
import { initFilters } from './components/category/filters.js'
import { initPages } from './components/pages.js'
import { initCart } from './components/cart/cart.js'
import { initGlobalFunctions } from './components/global.js'
import { initAdvancedOrder } from './components/advanced-order.js'
import { initDetail } from './components/detail/detail.js'
import './config.js'
import './components/base.js'
import { typePost } from "./components/blog/blog";
import { initProdejny } from "./components/prodejny/prodejny";

$(document).ready(function () {
    const body = $('body')
    body.addClass('able-template-1')

    // Global
    initGlobalFunctions()
    initFooter()

    // Header
    initHeader()
    initNavigation()
    initPopupWidget()

    // Products
    initProducts()
    initAdvancedOrder()

    if (body.hasClass('type-index')) {
        initHomepage()
    }
    if (body.hasClass('type-detail')) {
        initDetail()
    }

    if (body.hasClass('type-category')) {
        initCategory()
        initFilters()
    }

    if (body.hasClass('ordering-process')) {
        initCart()
    }

    if (body.hasClass('type-page')) {
        initPages()
    }

    if (body.hasClass('type-posts-listing')) {
        initBlogListing()
    }

    if (body.hasClass('type-post')) {
        typePost()
    }

    if (body.hasClass('id-929')) {
        initProdejny()
    }

    body.addClass('ready')

    if ($(window).width() < 1400) {
        shoptet.menu.splitMenu()
    }

    console.log('Able JS loaded!')
})
